import Select from 'react-select';
import { setSearchType } from '../../redux/rulesSlice';
import { useDispatch, useSelector } from 'react-redux';
import '../../assets/styles.css';

export default function DropDownSearchType() {
    const searchType = useSelector(state => state.rules.searchType);
    const dispatch = useDispatch();
    const options = [
        { value: 'All', label: 'All'},
        { value: 'ID', label: 'ID' },
        { value: 'Name', label: 'Name' },
        { value: 'Condition', label: 'Condition' },
        { value: 'Data', label: 'Data' },
    ];

    const handleSearchTypeChange = (src) => {
        dispatch(setSearchType(src));
    };

    return (
        <div className='flex items-center gap-4 flex-nowrap'>
            <span className='w-130'>
                <Select options={options}
                    defaultValue={options.find(x => x.value === searchType)}
                    select onChange={(e) => handleSearchTypeChange(e.value)}
                />
            </span>
        </div>
    )
}